export default __webpack_public_path__ + "static/add@768-61c4ddf2ad02f58949c6f1b9640e9be5.svg";